import script from "./TimeFeature.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeFeature.vue?vue&type=script&lang=ts&setup=true"

import "./TimeFeature.vue?vue&type=style&index=0&id=4086efae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4086efae"]])

export default __exports__